import { render, staticRenderFns } from "./goodsManagement.vue?vue&type=template&id=496207f9&scoped=true&"
import script from "./goodsManagement.vue?vue&type=script&lang=js&"
export * from "./goodsManagement.vue?vue&type=script&lang=js&"
import style0 from "./goodsManagement.vue?vue&type=style&index=0&id=496207f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496207f9",
  null
  
)

export default component.exports